export const html2pdf = {
  "title": "Create PDF From Web Page",
  "EnterURL": "URL: ",
  "InvalidURL": "Invalid URL.",
  "notSupport": "This file format is not supported.",
  "selectDoc": "Choose File:",
  "browse": "Browse",
  "setting": "Settings",
  "cancel": "Cancel",
  "ok": "Create",
  "settingDlg": {
    "title": "Web Page Conversion Settings",
    "slice0": {
      "title": "Download"
    },
    "slice1": {
      "title": "General",
      "converseLevel": "Conversion Level",
      "convertOnly": "Convert only ",
      "levels": "Level (s)",
      "convertOnPath": "convert webpages on the same path",
      "convertOnServer": "convert webpages on the same server",
      "convertSite": "convert the entire site",
      "pdfSet": "PDF Settings",
      "setTimeOut": "Set Timeout: ",
      "seconds": "Seconds",
      "disableHyperlink": "Disable all hyperlinks in generated PDFs",
      "setSinglePDF": "Set all the page contents into one PDF page",
      "setBookMarks": "Create bookmarks",
      "setPdfTag": "Create PDF Tag",
      "setOptimizeTag": "Optimize tag tree"
    },
    "slice2": {
      "title": "Page Layout",
      "size": "Size: ",
      "pageSize": "Page Size: ",
      "width": "Width: ",
      "height": "Height: ",
      "margin": "Margins: ",
      "top": "Top: ",
      "bottom": "Bottom: ",
      "left": "Left: ",
      "right": "Right: ",
      "custom": "Custom",
      "orientation": "Orientation: ",
      "portrait": "Portrait",
      "landscape": "Landscape",
      "MediaStyle": "Media Style: ",
      "Scaling": "Scaling: "
    },
    "media_style": {
      "print": "Print",
      "screen": "Screen"
    },
    "scaling_type": {
      "noScale": "Fixed page with no scale",
      "scale": "Scale",
      "enlarge": "Enlarge"
    },
    "ok": "OK",
    "cancel": "Cancel"
  }
}